<template>
  <div>
    <div class="intro-x mt-8 headerBox">
      <div class="headerRight">
        <h2 class="headerTitle h2node">推广订单</h2>
        <h3 class="inputH3">
          <el-input
            v-model="input1"
            class="input"
            placeholder="请输入内容"
            prefix-icon="el-icon-search"
          >
          </el-input>
        </h3>
      </div>
      <h2 class="headerTitle">我的推广信息</h2>
    </div>
    <div class="itemBox" style="padding-bottom:20px">
      <div class="pro">
        <div class="w-12 h-12 image-fit">
          <img
            alt=""
            class="rounded-full"
            :src="
              userInfo.avatar ||
              'http://osssys.izhyin.cn/9_avatar.png?1610590122'
            "
          />
        </div>
        <div class="vip">
          {{ userInfo.nickname || '会员昵称 '}}<br />
          <span>会员id:{{ userInfo.uid }}</span>
        </div>
      </div>
      <div class="ztg">
        <div class="itemContent">{{ userInfo.invite_count }}</div>
        <div class="itemContent2">总推广订单数</div>
      </div>
      <div class="ztg">
        <div class="itemContent3">￥ {{ userInfo.invite_sum }}</div>
        <div class="itemContent4">总推广奖励</div>
      </div>

      <!-- <div class="list">
        <p>邀请链接:123456789</p>
        <el-button class="button" type="primary" size="small" round
          >复制</el-button
        >
      </div> -->

      <div v-if="userInfo.invite_code" class="list">
        <p>优惠码:{{ userInfo.invite_code }}</p>
        <el-button
          v-clipboard:copy="userInfo.invite_code"
          v-clipboard:success="onCopy"
          v-clipboard:error="onError"
          class="button"
          type="primary"
          size="small"
          >复制</el-button
        >
      </div>

      <div v-else class="buttonItem" @click="openMsg">
        点击获取我的专属优惠码
      </div>

      <div class="list">
        <p>推广佣金比例</p>
        <p v-if="userInfo.invite_code">{{ userInfo.discount.promo_commission_rate  }}%</p>
        <p v-else style="color: #999999; font-size: 14px;line-height: 23px;margin-right: 10px">请获取优惠码</p>
        <el-popover
                placement="top-start"
                width="200"
                trigger="hover"
                content="被推荐人在智莺系统购买应用时，使用专属邀请码，推荐人可获付款金额*推广佣金比例的推荐奖励">
          <div class="tb" slot="reference">?</div>
        </el-popover>
      </div>
      <div class="list">
        <p>优惠码折扣</p>
        <p v-if="userInfo.invite_code">{{ userInfo.discount.discount_code_rate * 1  }}折</p>
        <p v-else style="color: #999999; font-size: 14px;line-height: 23px;margin-right: 10px">请获取优惠码</p>
        <el-popover
                placement="top-start"
                width="200"
                trigger="hover"
                content="推荐其他用户在智莺系统购买应用时，使用专属邀请码，被推荐人可以享受优惠折扣">
          <div class="tb" slot="reference">?</div>
        </el-popover>
      </div>

      <div class="listWarning">记得提醒好友付款时使用优惠码哦~</div>
    </div>
    <div class="itemBoxB">
      <el-table :data="tableData" stripe style="width: 100%; height: 800px">
        <el-table-column width="100">
          <el-avatar
            src="https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png"
          ></el-avatar>
        </el-table-column>
        <el-table-column prop="invitee_nickname" label="好友昵称" width="250">
        </el-table-column>
        <el-table-column prop="bonus" label="奖励金额" width="250">
        </el-table-column>
        <el-table-column prop="ctime" label="时间"> </el-table-column>
      </el-table>
      <!-- 页面分页设置 -->
      <div class="block">
        <el-pagination
          :current-page.sync="currentPage2"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="10"
          layout="sizes, prev, pager, next"
          :total="1000"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>
    </div>
    <div class="zskf">我的专属客服经理</div>
    <div class="itemBoxC">
      <div class="manager-left">
        <div class="imgDiv">
          <img
              :src="userInfo.avatar || 'http://osssys.izhyin.cn/9_avatar.png?1610590122'"
            alt=""
          />
        </div>
        <div class="managerNmae">Robert De Niro</div>
        <div class="managerPhone">电话：1123451516125</div>
      </div>
      <!-- 二维码 -->
      <img class="rightCode" src="@/assets/images/profile-1.jpg" alt="" />
    </div>
<!--    消息提示弹窗-->
    <Msg v-if="isMsg" @goBuy="goBuy" @setCancel="setCancel"></Msg>
  </div>
</template>

<script>
import Cookies from "js-cookie";
import Msg from '../modules/Msg'
import request  from '../utils/request'


export default {
  components:{
    Msg
  },
  data() {
    return {
      // 弹窗开关
      isMsg:false,
      input1: "",
      currentPage2: 1,
      tableData: [],
    };
  },
  computed: {
    userInfo: function () {
      return JSON.parse(Cookies.get("userInfo"));
    },
  },
  mounted() {
    this.getInviteList();
  },
  methods: {
    // 复制成功时的回调函数
    onCopy(e) {
      this.$message.success("内容已复制到剪切板！");
    },
    // 复制失败时的回调函数
    onError(e) {
      this.$message.error("抱歉，复制失败！");
    },

    handleSizeChange(val) {
      // console.log(`每页 ${val} 条` ,1);
    },
    handleCurrentChange(val) {
      // console.log(`当前页: ${val}`);
    },

    getInviteList: function () {
      request({
        url:"/api/invite/list/1/10",
      }).then((res) => {
        this.tableData = res.data;
      });
    },
// 购买弹窗
    openMsg: function () {
      this.isMsg = true
    },
    // 购买操作
    goBuy(){
      this.isMsg = false
      this.$router.push("/Dashboard/myApp/CreateAn");
    },
    // 取消弹窗
    setCancel(){
      this.isMsg = false
    }
    // getAlert: function () {
    //   this.$confirm(
    //     "消费满 5000 元后马上拥有专属邀请码，拥有邀请码后即可开始推广赚钱！",
    //     "温馨提示",
    //     {
    //       confirmButtonText: "前往购买",
    //       cancelButtonText: "取消",
    //       type: "warning",
    //     }
    //   )
    //     .then(() => {
    //       this.$router.push("/Dashboard/myApp/CreateAn");
    //     })
    //     .catch(() => {
    //       console.log("用户点击了取消");
    //     });
    // },
  },
};
</script>

<style lang="scss">
.headerBox {
  overflow: hidden;
  .headerTitle {
    color: #2d3748;
    font-size: 18px;
    float: left;
  }

  .headerRight {
    float: right;
    width: 70.7%;
  }

  .inputH3 {
    float: right;
  }
}

.itemBox {
  width: 25.8%;

  background: #fff;
  float: left;
  margin-top: 30px;
  border-radius: 22px;
  box-sizing: border-box;

  .list {
    margin: 5% auto;
    background: #f4f7f8;
    justify-content: space-between;
    border-radius: 2rem;
    position: relative;
    width: 90%;
    .button {
      position: absolute;
      top: 26%;
      right: 5%;
      width: 68px;
      height: 32px;
    }
    p {
      padding: 0 0 0 5%;
      line-height: 60px;
      font-size: 14px;
    }
    p:nth-child(2) {
      position: absolute;
      top: 30%;
      right: 15%;
      color: #1890ff;
      font-size: 20px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      line-height: 20px;
    }
    .tb {
      position: absolute;
      top: 33%;
      right: 7%;
      border-radius: 50%;
      width: 20px;
      height: 20px;
      background: #1890ff;
      color: #fff;
      text-align: center;
      line-height: 20px;
      cursor:pointer;
    }
  }
  .el-alert--warning.is-light {
    background-color: #fdf6ec;
    color: #966900;
    width: 90%;
    margin: auto;
  }
  .ztg {
    display: inline-block;
    text-align: center;
    width: 50%;
    .itemContent {
      font-size: 28px;
      color: #1890ff;
      font-weight: bold;
    }
    .itemContent2 {
      color: #718096;
      font-size: 14px;
    }
    .itemContent3 {
      font-size: 28px;
      color: #6fd04f;
      font-weight: bold;
    }
    .itemContent4 {
      color: #718096;
      font-size: 14px;
    }
  }
  .el-alert--warning.is-light {
    height: 26px;
    line-height: 26px;
    overflow: hidden;
    text-align: center;
    .el-alert__content {
      height: 100%;
      text-align: center;
    }
  }
}

.itemBoxB {
  width: 70.7%;
  height: 924px;
  background: #fff;
  float: right;
  margin-top: 30px;
  border-radius: 22px;
  box-sizing: border-box;
  padding: 1.6%;
  overflow: hidden;
  .block {
    .el-pager li.active {
      background: #1890ff;
      color: #fff !important;
    }
    .el-pagination__sizes {
      margin: 5px;
      float: right;
      font-weight: 400;
      color: #606266;
    }
    .el-pagination .el-select .el-input .el-input__inner {
      padding-right: 30px;
      border-radius: 7px;
      background: #1890ff;
      height: 35px;

      box-shadow: 0px 3px 20px rgba(0, 0, 0, 0.03);
    }
    .el-pagination__sizes .el-input .el-input__inner {
      font-size: 14px;
      padding-left: 8px;
      color: #fff;
      font-family: Microsoft YaHei;
    }
  }
}
.zskf {
  float: left;
  margin: 2%;
  font-size: 1.125rem;
  font-weight: 500;
}
.itemBoxC {
  width: 25.8%;
  height: 115px;
  background: #fff;
  float: left;
  border-radius: 22px;
  box-sizing: border-box;
  padding: 12px;

  .manager-left {
    float: left;
    .imgDiv {
      float: left;
      width: 100%;
      img {
        width: 42px;
        height: 42px;
        border-radius: 50%;
        overflow: hidden;
      }
    }
  }
  .manager-left .managerNmae {
    font-size: 14px;
    font-weight: 400;
    line-height: 19px;
    color: #080e18;
    opacity: 1;
    margin: 6px 0;
  }
  .manager-left .managerPhone {
    font-size: 12px;
    font-weight: 300;
    line-height: 16px;
    color: #718096;
    opacity: 1;
  }
  .rightCode {
    width: 91px;
    height: 91px;
    float: right;
  }
}
div {
  .s-button {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .input {
    width: 254px;
    height: 40px;
    .el-input__prefix,
    .el-input__suffix {
      top: 20%;
      left: 20px;
    }
  }
}
.pro {
  margin: 5%;
  display: flex;
  .vip {
    margin: 0 16px;
    line-height: 26px;
    span {
      color: #718096;
    }
  }
  .el-alert {
    width: 100%;
    bottom: 10px;
    padding: 0;
  }
}

// 响应式
@media screen and (max-width:600px) {
  .input {
    padding-left: 0 !important;
  }
  .itemBox {
    width: 100% !important;
    .el-alert--warning.is-light {
      height: 40px !important;
    }
  }

  .itemBoxC {
    width: 100% !important;
  }
  .s-button {
    display: none !important;
  }
  .headerRight {
    width: 100% !important;
    padding-bottom: 20px !important;
    .inputH3 {
      float: left !important;
      width: 100% !important;
    }
  }

  .h2node {
    display: none !important;
  }
}

// 响应式
@media screen and (max-width:1030px) {
  .input {
    padding-left: 0 !important;
  }
  .itemBox {
    width: 100% !important;
    height: auto !important;
    .el-alert--warning.is-light {
      height: 40px !important;
    }
  }
  .itemBoxB {
    width: 100% !important;
  }
  .itemBoxC {
    width: 100% !important;
  }
  .s-button {
    display: none !important;
  }
  .headerRight {
    width: 100% !important;
    padding-bottom: 20px !important;
    .inputH3 {
      float: left !important;
      width: 100% !important;
    }
  }

  .h2node {
    display: none !important;
  }
}

.listWarning {
  color: #966900;
  font-size: 14px;
  width: 90%;
  margin: auto;
  height: 30px;
  background: #fff5dc;
  opacity: 1;
  border-radius: 6px;
  text-align: center;
  line-height: 30px;
}

.buttonItem {
  width: 90%;
  text-align: center;
  line-height: 60px;
  cursor: pointer;
  margin: 20px auto 0;
  color: #fff;
  height: 60px;

  background: #1890ff;

  border-radius: 16px;
}

.buttonItem:active {
  background: #46a2f8;
}
</style>
